import Section from "@/components/site/Section";
import Icon from "@/components/site/Icon";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/primitives";
import { PERSONAS } from "@/lib/content";

export default function Personas() {
  return (
    <Section bg="surface" data-testid="personas">
      <Reveal className="max-w-3xl">
        <SectionHeading overline="Built Around the Traveler" title={<>Designed around what drivers actually need from a stop.</>} />
      </Reveal>

      <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:mt-16">
        {PERSONAS.map((p, i) => (
          <Reveal key={p.title} delay={(i % 3) * 0.06}>
            <div className="group h-full rounded-2xl border border-white/10 bg-rp-card p-7 transition-colors duration-300 hover:border-rp-accent/40" data-testid={`persona-${i}`}>
              <div className="grid h-12 w-12 place-items-center rounded-xl border border-white/10 text-rp-accent transition-colors duration-300 group-hover:border-rp-accent/50">
                <Icon name={p.icon} className="h-6 w-6" strokeWidth={1.5} />
              </div>
              <h3 className="mt-5 font-display text-xl font-medium tracking-tight text-white">{p.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/55">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
